<template>
  <div>
    <v-menu
      v-model="menu"
      transition="slide-y-transition"
      :close-on-content-click="false"
      left
      min-width="300"
      max-width="300"
      max-height="70vh"
    >
      <!-- Head card (na app-bar) - BTN MENU Iniciais + Titulo SALDO e subtitulo Currency (R$) -->
      <template v-slot:activator="{ on }">
        <v-card
          flat
          :class="!$isRetailSimplifiedOnly() ? 'ml-4' : ''"
          color="transparent"
        >
          <div class="d-flex align-center">
            <div
              v-if="!$isCreditOnline() && !$isRetailSimplifiedOnly()"
              class="text-right"
              style="width: auto"
            >
              <div class="caption grey--text">
                {{ $t("BALANCE") }}
              </div>
              <div v-if="balanceVisibility" class="caption">
                {{ $t("labelCurrency") }}&nbsp;{{ cash | saldo }}
              </div>
              <div v-else>
                <div class="caption">• • • • •</div>
              </div>
            </div>
            <div v-else>
              <div v-if="cash > 0" class="text-right" style="width: auto">
                <div class="caption grey--text">{{ $t("BALANCE") }}</div>
                <div v-if="balanceVisibility" class="caption">
                  {{ $t("labelCurrency") }}&nbsp;{{ cash | saldo }}
                </div>
                <div v-else>
                  <div class="caption">• • • • •</div>
                </div>
              </div>
              <div v-else class="caption mr-0">
                <div v-if="!$isRetailSimplifiedOnly()">
                  <v-btn color="green" x-small @click="showDialogDeposit()">
                    <v-icon left size="24">mdi-plus</v-icon>
                    {{ $t("deposit") }}
                  </v-btn>
                </div>
              </div>
            </div>

            <div>
              <v-btn
                v-if="!menu"
                fab
                depressed
                small
                v-on="on"
                color="primary white--text"
                :class="!$isRetailSimplifiedOnly() ? 'ml-4' : ''"
                >{{ initialsName }}</v-btn
              >
              <v-btn
                v-else
                fab
                small
                outlined
                :class="!$isRetailSimplifiedOnly() ? 'ml-4' : ''"
                ><v-icon small>mdi-window-close</v-icon></v-btn
              >
            </div>
          </div>
        </v-card>
      </template>
      <!-- Head card END -->

      <!-- Card body -->
      <CardMenuRetailSimplifiedOnly v-if="$isRetailSimplifiedOnly()" />

      <v-card v-else>
        <v-list>
          <!-- 1ª parte: Avatar, Nome, ações -->
          <v-list-item>
            <v-list-item-avatar color="primary white--text">{{
              initialsName
            }}</v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="text-truncate">{{
                userInfo.nome_usuario
              }}</v-list-item-title>
            </v-list-item-content>

            <!-- ações -->
            <v-list-item-action>
              <div class="d-flex align-center">
                <!-- BTN atualizar saldo -->
                <v-tooltip
                  v-if="$isCreditOnline()"
                  bottom
                  :disabled="$vuetify.breakpoint.smAndDown"
                  z-index="999"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      :loading="updatingBalance"
                      @click="refreshBalance"
                      :disabled="disableUpdateBalance"
                    >
                      <v-icon dense class=""> mdi-autorenew </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("refreshBalance") }}</span>
                </v-tooltip>
                <!-- BTN Esconder/Mostrar -->
                <v-tooltip
                  v-if="$isCreditOnline()"
                  bottom
                  :disabled="$vuetify.breakpoint.smAndDown"
                  z-index="999"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="ml-1"
                      v-on="on"
                      icon
                      @click="toggleBalanceVisibility"
                    >
                      <v-icon dense class="">
                        {{
                          balanceVisibility
                            ? "mdi-eye-outline"
                            : "mdi-eye-off-outline"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ changeBalanceVisibilityTooltipMessage }}</span>
                </v-tooltip>
              </div>
            </v-list-item-action>
          </v-list-item>
          <!-- 1ª parte: Avatar, Nome, ações END -->

          <v-divider></v-divider>

          <!-- <v-divider style="opacity: 0.22"></v-divider> -->

          <!-- 2ª parte: Saldo e Bonus Dispoíveis -->
          <v-container>
            <v-row class="px-4 py-3">
              <!-- SALDO -->
              <v-col cols="6" class="pa-0">
                <div class="text-start">
                  <div class="caption grey--text">{{ $t("BALANCE") }}</div>
                  <div
                    v-if="balanceVisibility"
                    class="font-weight-bold"
                    style="width: auto"
                  >
                    {{ $t("labelCurrency") }}&nbsp;{{ cash | saldo }}
                  </div>
                  <div v-else>
                    <span>• • • • •</span>
                  </div>
                </div>
              </v-col>

              <!-- BÔNUS -->
              <v-col cols="6" class="pa-0">
                <div class="text-start" v-if="hasBonusBalance">
                  <div class="caption grey--text">{{ $t("BONUS") }}</div>
                  <div v-if="balanceVisibility" class="font-weight-bold">
                    {{ $t("labelCurrency") }}&nbsp;{{ cashBonus.value | saldo }}
                  </div>
                  <div v-else>
                    <span>• • • • •</span>
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Saldo disponível e saldo restrito -->
            <v-row class="px-4 py-3 mt-0">
              <!-- SALDO -->
              <v-col cols="12" class="pa-0">
                <div class="text-start">
                  <div class="caption grey--text">
                    {{ $t("availableToCashout") }}
                  </div>
                  <div
                    v-if="balanceVisibility"
                    class="font-weight-bold"
                    style="width: auto"
                  >
                   {{ availableBalance }}
                  </div>
                  <div v-else>
                    <span>• • • • •</span>
                  </div>
                </div>
              </v-col>

              <!-- BÔNUS -->
              <!-- <v-col cols="6" class="pa-0">
                <div class="text-start">
                  <div class="caption grey--text">
                    {{ $t("restrictBalance") }}
                  </div>
                  <div v-if="balanceVisibility" class="font-weight-bold">
                    {{ restrictedBalance }}
                  </div>
                  <div v-else>
                    <span>• • • • •</span>
                  </div>
                </div>
              </v-col> -->
            </v-row>
          </v-container>
          <!-- 2ª parte: Saldo e Bonus Dispoíveis END -->

          <!-- 3ª parte: Depositar -->
          <v-divider></v-divider>
          <div class="px-4 my-4" v-if="$isCreditOnline()">
            <v-btn
              block
              elevation="4"
              color="success"
              @click="showDialogDeposit()"
            >
              <v-icon left>mdi-upload</v-icon>
              {{ $t("deposit") }}
            </v-btn>
          </div>
          <!-- 3ª parte: Depositar END -->

          <!-- Menu Ícones -->
          <v-divider class="mb-2"></v-divider>
          <v-container v-if="$isCreditOnline()">
            <v-row dense>
              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Apostas'"
                  @click="goToRoute('SportBets')"
                >
                  <div>
                    <v-icon large>mdi-ticket-confirmation-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption">{{ $t("bets") }}</span>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Banco'"
                  @click="goToRoute('Banco')"
                >
                  <div>
                    <v-icon large>mdi-bank-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption">{{ $t("bank") }}</span>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="
                    $route.name === 'MyPromotions' &&
                      $route.query.openDialogToken
                  "
                  @click="
                    (menu = false),
                      $router.push({
                        name: 'MyPromotions',
                        query: { openDialogToken: true },
                      })
                  "
                >
                  <div>
                    <v-icon large>mdi-sale-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption" v-html="$t('menuRedeemToken')"></span>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="$isCreditOnline()" cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'MyPromotions'"
                  @click="goToRoute('MyPromotions')"
                >
                  <div>
                    <v-icon large>mdi-gift-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption">{{ $t("myPromotions") }}</span>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Mensagens'"
                  @click="goToRoute('Mensagens')"
                >
                  <div>
                    <v-icon large>mdi-email-outline</v-icon>
                    <v-badge
                      overlap
                      v-show="messagesNotRead > 0"
                      :content="messagesNotRead"
                    ></v-badge>
                  </div>
                  <div>
                    <span class="caption">{{ $t("messages") }}</span>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Perfil'"
                  @click="goToRoute('Perfil')"
                >
                  <div>
                    <v-icon large>mdi-account-circle-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption">{{ $t("profile") }}</span>
                  </div>
                </v-card>
              </v-col>

              <!-- 4ª parte: Meu painel e Ir para o Site END -->
              <v-col cols="4" v-if="hasVerificationStatus">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Verify'"
                  @click="goToRoute('Verify')"
                >
                  <div>
                    <v-icon large>mdi-shield-check-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption">{{
                      $t("verification.pageName")
                    }}</span>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.matched[0].name === 'main'"
                  @click="(menu = false), $router.push('/')"
                >
                  <div>
                    <v-icon large>mdi-home-outline</v-icon>
                  </div>
                  <div>
                    <span class="caption">{{ $t("goToWebsite") }}</span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-container v-else>
            <v-row dense>
              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Apostas'"
                  @click="goToRoute('Apostas')"
                >
                  <div>
                    <v-icon large>mdi-ticket-confirmation-outline</v-icon>
                  </div>
                  <div>
                    <div class="caption">{{ $t("bets") }}</div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Banco'"
                  @click="goToRoute('Banco')"
                >
                  <div>
                    <v-icon large>mdi-bank-outline</v-icon>
                  </div>
                  <div>
                    <div class="caption">{{ $t("bank") }}</div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Mensagens'"
                  @click="goToRoute('Mensagens')"
                >
                  <div>
                    <v-icon large>mdi-email-outline</v-icon>
                    <v-badge
                      overlap
                      v-show="messagesNotRead > 0"
                      :content="messagesNotRead"
                    ></v-badge>
                  </div>
                  <div>
                    <div class="caption">{{ $t("messages") }}</div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="2"></v-col>
              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.name === 'Perfil'"
                  @click="goToRoute('Perfil')"
                >
                  <div>
                    <v-icon large>mdi-account-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="caption">{{ $t("profile") }}</div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="4">
                <v-card
                  class="text-center py-3 btnMenu"
                  flat
                  :disabled="$route.matched[0].name === 'main'"
                  @click="(menu = false), $router.push('/')"
                >
                  <div>
                    <v-icon large>mdi-home-outline</v-icon>
                  </div>
                  <div>
                    <div class="caption">{{ $t("goToWebsite") }}</div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="2"></v-col>
            </v-row>
          </v-container>
        </v-list>
        <!-- Menu Ícones END -->

        <v-divider></v-divider>

        <!-- Footer: Sair -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="doLogout()"
            >{{ $t("exit") }} <v-icon right>mdi-exit-to-app</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
      <!-- Body card END-->
    </v-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CardMenuRetailSimplifiedOnly from "../../views/dashboard/_components/cardUserMenuRetailSimplifiedOnly/cardMenuRetailSimplifiedOnly.vue";
export default {
  name: "User",
  components: {
    CardMenuRetailSimplifiedOnly,
  },
  data: () => ({
    userInfo: "",
    firstName: "",
    initialsName: "",
    balanceVisibility: true,
    updatingBalance: false,
    disableUpdateBalance: false,
    menu: false,
  }),
  computed: {
    ...mapState(["cash", "dialogDeposit", "cashBonus", "messagesNotRead"]),
    changeBalanceVisibilityTooltipMessage() {
      return this.balanceVisibility
        ? this.$t("hideBalance")
        : this.$t("showBalance");
    },
    hasBonusBalance() {
      return (
        this.cashBonus.value > 0 &&
        this.cashBonus.status == 1 &&
        this.$isCreditOnline()
      );
    },
    hasVerificationStatus() {
      return this.$store.getters.getVerificationSteps.length > 0;
    },
    availableBalance() {
      const value = this.$store.state.availableBalance;

      if (value) {
        return Number(value).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          style: "currency",
          currency: "BRL",
        });
      }

      return 0;
    },
    restrictedBalance() {
      const value = this.$store.state.restrictedBalance;

      if (value) {
        return Number(value).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          style: "currency",
          currency: "BRL",
        });
      }

      return 0;
    },
  },
  mounted() {
    this.userInfo = this.$store.state.logged.data;
    // console.log(this.cashBonus);
    if (this.$isCreditOnline()) {
      const storageKey = `balanceVisibility${this.userInfo.id_usuario}`;
      const balanceVisibilityPreference = localStorage.getItem(storageKey);
      if (balanceVisibilityPreference) {
        const parsedPreference = JSON.parse(balanceVisibilityPreference);
        this.balanceVisibility = parsedPreference;
      }
    }
  },
  watch: {
    "userInfo.nome_usuario": function(val) {
      this.initials(val);
    },
    $route(val) {
      if (val.name === "casino") {
        this.refreshBalance();
      }
    },
  },
  methods: {
    goToRoute(name) {
      this.menu = false;
      this.$router.push({ name });
    },
    refreshBalance() {
      this.updatingBalance = true;
      this.$axios
        .get("/player/online/bank/balanceOnline")
        .then((res) => {
          this.$store.commit("setCash", res.data.dados.balance);
          this.$store.commit("setBonus", {
            value: res.data.dados.balance_bonus,
            status: res.data.dados.balance_bonus_status,
          });
          this.$store.commit("setAvailableBalance", res.data.dados.available_balance);
          this.$store.commit("setRestrictedBalance", res.data.dados.restricted_balance);
        })
        .finally(() => {
          this.updatingBalance = false;
          this.disableUpdateBalance = true;
          setTimeout(() => {
            this.disableUpdateBalance = false;
          }, 5000);
        });
    },
    toggleBalanceVisibility() {
      this.balanceVisibility = !this.balanceVisibility;
      const storageKey = `balanceVisibility${this.userInfo.id_usuario}`;
      const stringifiedPreference = JSON.stringify(this.balanceVisibility);
      localStorage.setItem(storageKey, stringifiedPreference);
    },
    // Return firstName and Iniciais do Nome
    initials(name) {
      var names = name.split(" ");
      this.firstName = names[0];
      this.initialsName = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        this.initialsName += names[names.length - 1]
          .substring(0, 1)
          .toUpperCase();
      }
    },
    showDialogDeposit() {
      this.$store.commit("dialogDeposit", true);
    },
    doLogout() {
      this.menu = false;

      if (this.$route.path.includes("/myBets")) {
        this.$router.push({ name: "main" });
      }
      this.$logout();
    },
  },
  filters: {
    saldo: function(value) {
      return value == undefined || value == null
        ? "00,00"
        : Number(value).toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
div[role="menu"] {
  margin-top: 2.8rem;
}

.btnMenu {
  transition: 0.2s ease;
}
.btnMenu:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
